export default class FormZip {
    static init(): void {
        this.getCityRegionByZip();
    }

    // Změněno na výběr podle třídy místo ID
    static getCityRegionByZip(zipClass = '.address-zip-validation'): void {
        const zipInputs = document.querySelectorAll(zipClass) as NodeListOf<HTMLInputElement>; // Výběr všech inputů s třídou smartform-address-zip

        interface CityRegion {
            city: string;
            region: string;
            id: number;
        }

        // Pro každý nalezený input s třídou smartform-address-zip spustíme logiku
        zipInputs.forEach((zipInput) => {
            // Hide region and city select input parent elements initially
            const regionInput = document.querySelector('#place-select') as HTMLSelectElement;
            const cityInput = document.querySelector('#smartform_obec') as HTMLInputElement;
            const formGroup = zipInput?.closest('.form-group') as HTMLDivElement;

            if (
                regionInput &&
                cityInput &&
                regionInput.parentElement &&
                cityInput.parentElement &&
                zipInput.value.length === 0
            ) {
                regionInput.parentElement.style.display = 'none';
                cityInput.parentElement.style.display = 'none';
            }

            zipInput?.addEventListener('input', () => {
                window.setTimeout(() => {
                    // send POST xml request to get city and area JSON
                    const xhr = new XMLHttpRequest();
                    xhr.open('GET', '?do=CityRegionByZip&zip=' + zipInput.value, true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            const response: CityRegion[] = JSON.parse(xhr.responseText);
                            if (response.length === 0) {
                                console.error('PSC nebylo nalezeno');
                                zipInput.classList.add('form-control--error');
                                formGroup?.classList.add('form-group--error');
                                return;
                            } else {
                                console.info('PSC nalezeno');
                                zipInput.classList.remove('form-control--error');
                                formGroup?.classList.remove('form-group--error');
                            }

                            const regionInput = document.querySelector('#place-select') as HTMLSelectElement;
                            const cityInput = document.querySelector('#smartform_obec') as HTMLInputElement;

                            if (cityInput && regionInput && cityInput.parentElement && regionInput.parentElement) {
                                // Replace cityInput with select
                                const citySelect = document.createElement('select');
                                citySelect.id = 'smartform_obec';
                                citySelect.name = cityInput.name; // Set the name attribute to be the same as the original cityInput
                                citySelect.classList.add('form-control', 'form-control--select');

                                // Populate select with available cities from response
                                response.forEach((cityRegionObj: CityRegion) => {
                                    const option = document.createElement('option');
                                    option.value = cityRegionObj.id.toString();
                                    option.text = cityRegionObj.city;
                                    citySelect.add(option);
                                });

                                // Replace the original input element with the new select element
                                cityInput.parentElement.replaceChild(citySelect, cityInput);

                                // Set the values for city and region
                                citySelect.value = response[0].id.toString();
                                regionInput.value = response[0].region;

                                // Call onChange event on the regionInput
                                regionInput.dispatchEvent(new Event('change'));

                                // Show region and city select input parent elements
                                if (regionInput.parentElement && citySelect.parentElement) {
                                    // remain hidden
                                    // regionInput.parentElement.style.display = '';
                                    // citySelect.parentElement.style.display = '';
                                }
                            } else {
                                console.error(
                                    'Could not find cityInput or regionInput elements or their parent elements',
                                );
                            }
                        }
                    };
                    xhr.send();
                }, 200);
            });

            // Validace číselného vstupu pro ZIP kódy
            const numberInputs: NodeList = document.querySelectorAll('input[type="number"].input-zip');
            if (numberInputs.length > 0) {
                numberInputs.forEach((input: Node) => {
                    const htmlInput: HTMLInputElement = input as HTMLInputElement;
                    htmlInput.addEventListener('input', function (this: HTMLInputElement) {
                        this.value = this.value.replace(/[^0-9]/g, ''); // Povolení pouze čísel
                    });
                });
            }
        });
    }

}
